import { Dimensions } from '@/models/Dimensions';
import { Image } from '@/models/Image';
import { NetContent } from '@/models/NetContent';
import { Amount, Price } from '@/models/Price';
import type { Product, ProductCreate } from '@/models/Product';
import { ProductCategory } from '@/models/ProductCategory';
import { Promotion } from '@/models/Promotion';
import { Status } from '@/models/Status';
import { Supplier } from '@/models/Supplier';

interface PriceCreate {
  price: Amount;
}

interface PriceUpdate {
  price: Amount;
}

export enum SkuAssociation {
  PRICES = 'prices',
  PRODUCT = 'product',
  SUPPLIER = 'supplier',
  PROMOTIONS = 'promotions',
  ALL = 'all',
}

export interface Sku {
  id: string;
  code: string;
  productId: string;
  supplierId: string;
  externalCode: string;
  name: string;
  description: string;
  dimensions?: Dimensions;
  netContent?: NetContent;
  quantity?: number;
  moq?: number;
  images: Image[];
  customData?: { [key: string]: string };
  status: Status;
  product?: Product;
  prices?: Price[];
  supplier?: Supplier;
  promotions?: Promotion[];
  createdAt: Date;
  createdByStoreId?: string;
}

export interface Skus {
  items: Sku[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export type ProductSearchFacetCode = 'category' | 'promotion' | 'supplier';

export interface ProductSearchFacetValue {
  value: string;
  label: string;
  count?: number;
  estimatedCount?: number;
  available: boolean;
}

export interface ProductSearchFacet {
  code: ProductSearchFacetCode;
  name: string;
  values: ProductSearchFacetValue[];
}

export interface ProductSearchResult extends Skus {
  facets: ProductSearchFacet[];
}

export interface SkuMetrics {
  skuCount: number;
}

export interface SkuCreate {
  code: string;
  externalCode?: string;
  supplierId: string;
  name: string;
  description: string;
  images?: Image[];
  dimensions?: Dimensions;
  netContent?: NetContent;
  quantity?: number;
  moq?: number;
  status?: Status;
  productId?: string;
  product?: ProductCreate;
  productCategoryId?: string;
  productCategoryName?: string;
  productCategory?: ProductCategory;
  price?: PriceCreate;
  prices?: Price[];
  supplier?: Supplier;
}

export interface SkuUpdate {
  id: string;
  code: string;
  externalCode?: string;
  productId: string;
  supplierId: string;
  name: string;
  description: string;
  images?: Image[];
  dimensions?: Dimensions;
  netContent?: NetContent;
  quantity?: number;
  moq?: number;
  status?: Status;
  product?: Product;
  price?: PriceUpdate;
  prices?: Price[];
  supplier?: Supplier;
}
